import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { CourseFaqsDetailPage } from './course/faqs'
import {
  CourseLivePage,
  CourseLiveRecordingPage,
  CourseLiveSessionsListPage,
  CourseLiveSessionScheduleNewPage,
  CourseLiveSessionScheduleEditPage,
  LiveStreamsEntrypoints,
  LiveStreamsLanding,
} from './course/live'
import CourseUnitPage from './course/unit/component'
import { ProjectPage } from './projects'
/* eslint-disable react/jsx-props-no-spreading */

const Routes = props => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/:lang" component={() => <LiveStreamsEntrypoints />} />
      <Route exact path="/:lang/live-stream" component={() => <LiveStreamsLanding />} />
      <Route exact path="/:lang/my_courses" component={() => <LiveStreamsEntrypoints />} />
      <Route exact path="/:lang/courses/:id/units/:id" component={() => <CourseUnitPage {...props} />} />
      <Route exact path="/:lang/courses/:id/faqs/:id" component={() => <CourseFaqsDetailPage {...props} />} />
      <Route exact path="/:lang/courses/:id/lives" component={() => <CourseLiveSessionsListPage {...props} />} />
      <Route
        exact
        path="/:lang/courses/:id/lives/new"
        component={() => <CourseLiveSessionScheduleNewPage {...props} />}
      />
      <Route
        exact
        path="/:lang/courses/:id/lives/:id/edit"
        component={() => <CourseLiveSessionScheduleEditPage {...props} />}
      />
      <Route exact path="/:lang/courses/:id/lives/:id" component={() => <CourseLivePage {...props} />} />
      <Route
        exact
        path="/:lang/courses/:id/lives/:id/recording"
        component={() => <CourseLiveRecordingPage {...props} />}
      />
      <Route
        exact
        path={['/:lang/projects/new', '/:lang/projects/:idProjectName/edit']}
        component={() => <ProjectPage {...props} />}
      />
    </Switch>
  </BrowserRouter>
)

export default Routes
